import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AdaptiveAccessReport } from "@aptsi-types";
import { environment } from "@env";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorHandlingService } from "../shared/errorHandling/errorHandling.service";
import { API_ENDPOINTS } from "../ada-access-api-endpoints";

interface GetAssetViewsResponse {
  adaptiveaccessreport: AdaptiveAccessReport[];
}

@Injectable({
  providedIn: "root",
})
export class AdaptiveAccessReportService {
  private readonly adaptiveaccessreportsUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService
  ) {}
  
  getAcReports(selectedFilter: string): Observable<AdaptiveAccessReport[]> {
    return this.http
      .post<GetAssetViewsResponse>(
        `${this.adaptiveaccessreportsUrl}${API_ENDPOINTS.REPORT.FETCH}`,
        { selectedFilter }
      )
      .pipe(
        map((response) => response.adaptiveaccessreport),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

}
